<template>
    <div class="activity-page dis-align" v-show="visible">
        <div class="activity-c animated fadeInDown">
            <i class="el-icon-close" @click="close()"></i>
            <ad type="indexLayer" @finished="finished" ></ad>
            <el-checkbox v-model="checked" @change="change()">不再提示</el-checkbox>
        </div>
    </div>
</template>

<script>
import ad from './components/Ad'
export default {
    components: {
        ad
    },
    data() {
        return {
            storageName: 'webchecker-activity2',
            visible: false,
            checked: false,
            toolkitId: '',
            isFrist:true
        }
    },
    methods: {
        finished(data) {
            if (data._id && !window.localStorage[this.storageName]) {
                this.visible = true;
            }
        },
        change() {
            window.localStorage[this.storageName] = this.checked ? '1' : '';
        },
        close() {
            this.visible = false;
        }
    }
}
</script>

<style lang="scss" scoped>
    .activity-page {
        position: fixed;
        top: 0;
        left: 0;
        z-index: 100;
        width: 100%;
        height: 100%;
        text-align: center;
        background-color: rgba(0,0,0,.8);
        .activity-other{
            img{
                max-width: 100%;
                max-height: 90vh;
            }
        }
    }
    .activity-c {
        position: relative;
        display: inline-block;
        font-size: 0;
        vertical-align: middle;
        img {
            max-width: 100%;
            max-height: 90vh;
            /*cursor: pointer;*/
        }
        .el-icon-close {
            $size: 30px;
            position: absolute;
            top: 0;
            right: -$size;
            font-size: $size;
            color: #fff;
            cursor: pointer;
        }
        .el-checkbox {
            position: absolute;
            bottom: -24px;
            left: 0;
            color: #fff;
        }
    }
</style>



// WEBPACK FOOTER //
// app/view/index/Activity.vue